<template>

  <div class="club-picker-container">

    <!-- <p class="section-title">{{ $country === 'US' ? 'Teams' : 'Clubs' }}</p> --> <!-- ADD -->

    <div> <!--  v-if="$country === 'FR'" --> <!-- ADD -->
    <p class="section-title">Clubs</p> <!-- REMOVE -->
      <div class="clubs-container" v-if="selectedClubs.length !== 0">

        <div class="clubs-row">
          <p class="clubs-column-title align-center">ID</p>
          <p class="clubs-column-title align-center">Alias</p>
          <p class="clubs-column-title align-center">Highlighted</p>
          <div></div>
        </div>

        <div class="clubs-row" v-for="club in selectedClubs" :key="club.id">
          <p class="align-center">{{ club.id }}</p>
          <p class="align-center">{{ club.alias.toUpperCase() }}</p>
          <v-checkbox class="ma-0" v-model="club.isPrimary" @change="clubHighlightChanged(club)"></v-checkbox>
          <v-icon title="Remove" @click="removeClub(club)">mdi-close-circle</v-icon>
        </div>

      </div>

      <v-layout justify-end="justify-end" row="row">
        <v-flex xs6="xs6">
          <NEWClubSelector ref="clubSelector"
                           @clubSelected="clubSelected"/>
        </v-flex>
        <v-flex xs3="xs3">
          <v-btn class="add-button" color="lightgrey" @click="addClub">Add</v-btn>
        </v-flex>
        <v-spacer></v-spacer>
      </v-layout>

    </div>

    <div v-if="$country === 'US'">
      <p class="section-title">Teams</p> <!-- REMOVE -->
      <div class="clubs-container" v-if="selectedTeams.length !== 0">

        <div class="clubs-row">
          <p class="clubs-column-title align-center">Name</p>
          <p class="clubs-column-title align-center">Club</p>
          <p class="clubs-column-title align-center">Highlighted</p>
          <div></div>
        </div>

        <div class="clubs-row" v-for="team in selectedTeams" :key="team.id">
          <p class="align-center">{{ team.name.toUpperCase() }}</p>
          <p class="align-center">{{ team.clubAlias.toUpperCase() }}</p>
          <v-checkbox class="ma-0" v-model="team.isPrimary" @change="teamHighlightChanged(team)"></v-checkbox>
          <v-icon title="Remove" @click="removeTeam(team)">mdi-close-circle</v-icon>
        </div>

      </div>

      <v-flex xs6="xs6" class="pr-2">
        <NEWClubSelector ref="teamClubSelector"
                         @clubSelected="teamClubSelected"/>
      </v-flex>
      <v-layout justify-end="justify-end" row="row">
        <v-flex xs6="xs6">
          <TeamSelector ref="teamSelector"
                        :clubID="teamClubID"
                        :disabled="!teamClubID"
                        :disabledText="'Please select a club first'"
                        @teamSelected="teamSelected"/>
        </v-flex>
        <v-flex xs3="xs3">
          <v-btn class="add-button" color="lightgrey" @click="addTeam">Add</v-btn>
        </v-flex>
        <v-spacer></v-spacer>
      </v-layout>

    </div>

  </div>

</template>

<script>

import NEWClubSelector from '../common/NEWClubSelector'
import TeamSelector from '../common/TeamSelector.vue'

export default {
  name: 'ClubTeamPicker',
  components: {
    TeamSelector,
    NEWClubSelector
  },
  props: ['clubsID', 'teamsID'],
  data () {
    return {
      clubID: '',
      selectedClubs: [],

      teamID: '',
      teamClubID: '',
      selectedTeams: []
    }
  },
  methods: {
    clubSelected (clubid) {
      this.clubID = clubid
    },
    addClub (clubid, isPrimary) {
      if (this.clubID || clubid) {
        this.$store.dispatch('getClub', this.clubID || clubid)
          .then(resp => {
            if (this.selectedClubs.length !== 0) {
              for (const club of this.selectedClubs) {
                if (club.id === resp.id) {
                  alert('Club already selected')
                  this.clubID = null
                  return
                }
              }
            }
            this.selectedClubs.push({
              ...resp,
              isPrimary: isPrimary || false
            })
            this.$emit('clubSelected', {
              ...resp,
              isPrimary: isPrimary || false
            })
            this.clubID = null
            if (!clubid) {
              this.$refs.clubSelector.clear()
            }
          })
          .catch(() => {
            alert('Error selecting club')
          })
      }
    },
    clubHighlightChanged (club) {
      for (let selectedclub of this.selectedClubs) {
        if (selectedclub.id === club.id) {
          selectedclub.isPrimary = club.isPrimary
          this.$emit('primaryClubChange', {
            id: club.id,
            isPrimary: club.isPrimary
          })
        }
      }
    },
    removeClub (club) {
      this.selectedClubs.splice(this.selectedClubs.indexOf(club), 1)
      this.$emit('clubRemoved', club)
    },
    teamClubSelected (clubid) {
      this.teamClubID = clubid
    },
    teamSelected (teamid) {
      this.teamID = teamid
    },
    addTeam (teamid, isPrimary, addOnlyTeam) {
      if (this.teamID || teamid) {
        this.$store.dispatch('getTeam', this.teamID || teamid)
          .then(resp => {
            if (this.selectedTeams.length !== 0) {
              for (const team of this.selectedTeams) {
                if (team.id === resp.id) {
                  alert('Team already selected')
                  this.teamClubID = null
                  this.teamID = null
                  return
                }
              }
            }
            this.selectedTeams.push({
              ...resp,
              isPrimary: isPrimary || false
            })
            if (!addOnlyTeam) {
              this.addClub(resp.clubID)
            }
            this.$emit('teamSelected', {
              ...resp,
              isPrimary: isPrimary || false
            })
            this.teamClubID = null
            this.teamID = null
            this.$refs.teamClubSelector.clear()
            this.$refs.teamSelector.clear()
          })
          .catch(() => {
            alert('Error selecting team')
          })
      }
    },
    clear () {
      if (this.$refs.teamClubSelector) {
        this.$refs.teamClubSelector.clear()
      }
      if (this.$refs.teamSelector) {
        this.$refs.teamSelector.clear()
      }
      if (this.$refs.clubSelector) {
        this.$refs.clubSelector.clear()
      }
      this.clubID = ''
      this.selectedClubs = []
      this.teamID = ''
      this.teamClubID = ''
      this.selectedTeams = []
    },
    teamHighlightChanged (team) {
      for (let selectedteam of this.selectedTeams) {
        if (selectedteam.id === team.id) {
          selectedteam.isPrimary = team.isPrimary
          this.$emit('primaryTeamChange', {
            id: team.id,
            isPrimary: team.isPrimary
          })
          this.$emit('primaryClubChange', {
            id: team.clubID,
            isPrimary: team.isPrimary
          })
        }
      }
    },
    removeTeam (team) {
      let club = this.selectedClubs.find(club => club.id === team.clubID)
      this.removeClub(club)

      this.selectedTeams.splice(this.selectedTeams.indexOf(team), 1)
      this.$emit('teamRemoved', team)
    }
  }
}

</script>

<style lang="scss" scoped>

p {
  margin: 0;
}

.align-center {
  align-self: center;
}

.club-picker-container {
  margin: 12px 0 24px 0;
}

.section-title {
  font-weight: bold;
  margin-bottom: 12px;
}

.clubs-row {
  width: 100%;
  margin-bottom: 6px;
  display: grid;
  grid-template-columns: 30% 30% 30% 1fr;
  grid-column-gap: 6px;
}

.clubs-column-title {
  color: grey;
}

.v-input--selection-controls__ripple {
  margin: 0;
}

</style>

<style lang="scss">

.v-input__slot {
  margin: 0 !important;
}

</style>



// WEBPACK FOOTER //
// src/components/clips/ClubTeamPicker.vue